import {
  Accordion,
  Button,
  Modal,
  ModalAction,
  ModalSection,
  Icon,
} from '@monash/portal-react';
import c from './filter-modal.module.scss';

export const FilterModal = ({
  showModal,
  setShowModal,
  typeFilters,
  selectedTypes,
  setSelectedTypes,
  categoryFilters,
  selectedCategoryIds,
  setSelectedCategoryIds,
  cohortDropdownFilters,
  selectedCohortValues,
  setSelectedCohortValues,
}) => {
  const onItemClick = ({ value, selected, setSelected }) => {
    if (!selected.includes(value)) {
      setSelected([...selected, value]);
    } else {
      setSelected(selected.filter((selectedItem) => selectedItem !== value));
    }
  };

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      className={c.modalWrapper}
    >
      <ModalSection title="Filters">
        <div className={c.content}>
          <Accordion
            className={c.filterAccordion}
            hasExpandAll={false}
            useCustomStyles
            items={[
              {
                title: (
                  <div className={c.accordionTitleWrapper}>
                    <div className={c.title}>Type</div>
                    <div className={c.selectedText}>
                      {selectedTypes.length === 0
                        ? ''
                        : selectedTypes.length === 1
                        ? typeFilters.find(
                            (filter) => filter.value === selectedTypes[0]
                          )?.text
                        : `${selectedTypes.length} selected`}
                    </div>
                  </div>
                ),
                content: (
                  <>
                    <ul className={c.items} role="listbox">
                      {typeFilters.map(({ text, value }) => {
                        const isSelected = selectedTypes.includes(value);

                        return (
                          <li
                            key={value}
                            className={c.item}
                            role="option"
                            onClick={() =>
                              onItemClick({
                                value,
                                selected: selectedTypes,
                                setSelected: setSelectedTypes,
                              })
                            }
                          >
                            <span>{text}</span>
                            {isSelected && (
                              <Icon.Check className={c.tickIcon} />
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ),
              },
              {
                title: (
                  <div className={c.accordionTitleWrapper}>
                    <div className={c.title}>Categories</div>
                    <div className={c.selectedText}>
                      {selectedCategoryIds.length === 0
                        ? ''
                        : selectedCategoryIds.length === 1
                        ? categoryFilters.find(
                            (filter) => filter.value === selectedCategoryIds[0]
                          )?.text
                        : `${selectedCategoryIds.length} selected`}
                    </div>
                  </div>
                ),
                content: (
                  <>
                    <ul className={c.items} role="listbox">
                      {categoryFilters.map(({ text, value }) => {
                        const isSelected = selectedCategoryIds.includes(value);

                        return (
                          <li
                            key={value}
                            className={c.item}
                            role="option"
                            onClick={() =>
                              onItemClick({
                                value,
                                selected: selectedCategoryIds,
                                setSelected: setSelectedCategoryIds,
                              })
                            }
                          >
                            <span>{text}</span>
                            {isSelected && (
                              <Icon.Check className={c.tickIcon} />
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ),
              },
              {
                title: (
                  <div className={c.accordionTitleWrapper}>
                    <div className={c.title}>Location and Cohort</div>
                    <div className={c.selectedText}>
                      {selectedCohortValues.length === 0
                        ? ''
                        : selectedCohortValues.length === 1
                        ? cohortDropdownFilters.find(
                            (filter) => filter.value === selectedCohortValues[0]
                          )?.text
                        : `${selectedCohortValues.length} selected`}
                    </div>
                  </div>
                ),

                content: (
                  <>
                    <ul className={`${c.items} menu-wrapper`} role="listbox">
                      {cohortDropdownFilters.map(({ text, value }) => {
                        const isSelected = selectedCohortValues.includes(value);

                        return (
                          <li
                            key={value}
                            className={c.item}
                            role="option"
                            onClick={() =>
                              onItemClick({
                                value,
                                selected: selectedCohortValues,
                                setSelected: setSelectedCohortValues,
                              })
                            }
                          >
                            <span>{text}</span>
                            {isSelected && (
                              <Icon.Check className={c.tickIcon} />
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ),
              },
            ]}
          />
        </div>
      </ModalSection>

      <ModalAction position="right">
        <div className={c.actionBar}>
          <Button
            onClick={() => {
              setSelectedTypes([]);
              setSelectedCategoryIds([]);
              setSelectedCohortValues([]);
            }}
            size="small"
            variant="text"
          >
            Clear filters
          </Button>

          <Button onClick={() => setShowModal(false)} size="medium">
            Done
          </Button>
        </div>
      </ModalAction>
    </Modal>
  );
};
